const Skills = [
  {
    name: "React",
    icon: "mdi:react",
  },
  {
    name: "Redux",
    icon: "akar-icons:redux-fill",
  },
  {
    name: "JavaScript",
    icon: "fa6-brands:js",
  },
  {
    name: "HTML5",
    icon: "icomoon-free:html-five",
  },
  {
    name: "CSS3",
    icon: "ion:logo-css3",
  },
  {
    name: "Material UI",
    icon: "devicon-plain:materialui",
  },
  {
    name: "BootStrap",
    icon: "ri:bootstrap-fill",
  },
  {
    name: "Angular",
    icon: "teenyicons:angular-solid",
  },
  {
    name: "Cypress",
    icon: "devicon-plain:cypressio",
  },
  {
    name: "Node",
    icon: "fa6-brands:node",
  },
  {
    name: "Express",
    icon: "simple-icons:express",
  },
  {
    name: "MySQL",
    icon: "fontisto:mysql",
  },
  {
    name: "MongoDB",
    icon: "simple-icons:mongodb",
  },
  {
    name: "AWS",
    icon: "fa6-brands:aws",
  },
  {
    name: "Java",
    icon: "cib:java",
  },
  {
    name: "C#",
    icon: "devicon-plain:csharp",
  },
  {
    name: "Git",
    icon: "bi:git",
  },
  {
    name: "Jira",
    icon: "simple-icons:jira",
  },
];

export default Skills;
